<div class="feedback-message-container">
  <goab-icon
    class="warning-icon"
    [type]="iconType()"
    size="large"
    theme="outline"
    fillColor="black"
  ></goab-icon>

  <div class="feedback-message-text-wrapper">
    <h3 class="feedback-message-text-label">{{ title() }}</h3>
    <h3 class="feedback-message-text-second-label">{{ subtitle() }}</h3>
  </div>

  @for (textLine of textLines(); track textLine; let index = $index) {
  <goab-text class="feedback-message-sub-text-label">{{ textLine }}</goab-text>
  }
  <ng-content></ng-content>
</div>
